import { Button, Input, Form } from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { useLocalization } from "@i18n";
import type { StructureFilters } from "../../api/structures/structures.types";
import { Filter } from "lucide-react";

interface StructuresFilterProps {
  onFilter: (data: Partial<StructureFilters>) => void;
  onClear: () => void;
  initialFilters?: Partial<StructureFilters>;
}

export const StructuresFilter = ({
  onFilter,
  onClear,
  initialFilters,
}: StructuresFilterProps) => {
  const { translate } = useLocalization();

  const form = useForm<StructureFilters>({
    defaultValues: {
      name: initialFilters?.name ?? "",
      complexName: initialFilters?.complexName ?? "",
    },
  });

  const handleFilter = (data: StructureFilters) => {
    onFilter(data);
  };

  const handleClear = () => {
    form.reset();
    onClear();
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleFilter)}>
        <div className="flex flex-column gap-5">
          <Input
            control={form.control}
            label={`${translate("management.structures.form.label.name")}:`}
            name="name"
            type="text"
            placeholder={translate(
              "management.structures.form.placeholder.filterName",
            )}
          />
          <Input
            control={form.control}
            label={`${translate("management.structures.form.label.complexName")}:`}
            name="complexName"
            type="text"
            placeholder={translate(
              "management.structures.form.placeholder.filterComplexName",
            )}
          />
        </div>
        <div className="flex justify-end mb-4 gap-4">
          <Button type="button" variant="secondary" onClick={handleClear}>
            {translate("management.structures.button.clearFilters")}
          </Button>
          <Button type="submit" iconLeft={<Filter fill="currentColor" />}>
            {translate("management.structures.button.filter")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
